<template>
  <table class="desc-info-more">
    <tr>
      <th>감독</th>
      <td>
        <span v-for="(director, index) in contentInfo.directors.list" :key="'director' + index">
          <a href="#" @click.prevent="()=>searchByKeyword(director.value)">{{director.value}}</a>
          {{contentInfo.directors.list.length - 1 !== index ? ',' : ''}}
        </span>
      </td>
    </tr>
    <tr>
      <th>출연</th>
      <td>
        <span v-for="(actor, index) in contentInfo.actors.list" :key="'actor' + index">
          <a href="#" @click.prevent="()=>searchByKeyword(actor.value)">{{actor.value}}</a>
          {{contentInfo.actors.list.length - 1 !== index ? ',' : ''}}
        </span>
      </td>
    </tr>
    <tr>
      <th>줄거리</th>
      <td>{{contentInfo.synopsis}}</td>
    </tr>
    <tr>
      <th>개봉일자</th>
      <td>{{contentInfo.releasedate}}</td>
    </tr>
    <tr>
      <th>국가</th>
      <td>{{contentInfo.country}}</td>
    </tr>
  </table>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'MovieDescInfoMore',
  props: ['contentInfo'],
  methods: {
    searchByKeyword (keyword) {
      this.setCurrentSearchResultTab('all')
      this.setExternalInputSearchKeyword(keyword)
      this.deleteAllTag()
      this.hideSearchResult()
      this.$router.push('/search')
    },
    ...mapMutations({ setExternalInputSearchKeyword: 'setExternalInputSearchKeyword', deleteAllTag: 'deleteAllTag', hideSearchResult: 'hideSearchResult', setCurrentSearchResultTab: 'setCurrentSearchResultTab' })
  }
}
</script>
